<template>
  <div class="layout">
    <div class="container">
      <header class="header">
        <v-logo component="div">
          <template #suffix>Market Preview</template>
        </v-logo>
        <theme-switch />
      </header>
    </div>
    <section id="content" class="content container">
      <router-view />
    </section>
    <v-footer class="footer" />
    <modals />
  </div>
</template>

<script>
import VLogo from '@/components/VLogo';
import VFooter from '@/components/Bottombar';
import Modals from '@/components/Dialog';
import ThemeSwitch from '@/components/Topbar/ThemeSwitch.vue';

export default {
  components: {
    VFooter,
    Modals,
    VLogo,
    ThemeSwitch,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.layout {
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
}

.header {
  padding: 25px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @include notebook {
    padding: 10px 10px 10px 0;
  }
}

.content {
  padding: 15px 0;
}

.footer {
  margin-top: auto;
}
</style>
